import React from 'react'
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import parser from 'html-react-parser'

export default function ContentBlocks10({ data }) {
    const { contentBlocks10Authot, contentBlocks10ButtonText, contentBlocks10Title, contentBlocks10Text, contentBlocks10Quote, contentBlocks10Color, contentBlocks10ButtonLink, contentBlocks10Blocks, contentBlocks10Image, contentBlocks10BlockWidth, contentBlocks10ButtonExternalLinks } = data
    return (
        <div className='our-impact-page-sec-1 panel-space-70'>
            <div className='container sm-container-1'>
                <div className='row'>
                    <div className='col-md-12 text-center heading-head-sec'>
                        <h2 className='heading-level-2 blue-color mb-2'>
                            {contentBlocks10Title && parser(contentBlocks10Title)}
                        </h2>
                        {contentBlocks10Text && parser(contentBlocks10Text)}
                    </div>
                </div>
            </div>
            <div className='container'>
                <div className='row our-impact-row-1'>
                    <div className='col-md-6'>
                        <figure className='our-impact-lt-image-1'>
                            <GatsbyImage
                                image={getImage(contentBlocks10Image?.localFile)}
                                alt='image'
                            />
                        </figure>
                    </div>
                    <div className='col-md-6'>
                        <div className={`our-impact-rt-content-sec-1 ${contentBlocks10Color === 'green' ? 'green-light-bg' : 'dark-blue-bg-col'}  font-white`}>
                            <figure className='yellow-comma-icon'>
                                <StaticImage
                                    src='../../../images/yellow-comma.png'
                                    alt='image'
                                />
                            </figure>
                            <p>
                                <strong>{contentBlocks10Quote && parser(contentBlocks10Quote)}</strong>
                            </p>
                            <p>{contentBlocks10Authot && parser(contentBlocks10Authot)}</p>
                        </div>
                    </div>
                </div>

                <div className='row d-green-box-row our-impact-row-2'>
                    {contentBlocks10Blocks.map((block, i) => (
                        <div className={`col-md-${contentBlocks10BlockWidth} d-green-col-md`} key={i}>
                            <div className={`green-col-1 ${contentBlocks10Color === 'green' ? 'd-green-bx' : 'mid-blue-bg-col'}`}>
                                <div className={`heading-level-2 mb-2 ${contentBlocks10Color === 'green' ? 'pink-color' : 'white-color'} `}>
                                    {block.contentBlocks10BlockTitle && parser(block.contentBlocks10BlockTitle)}
                                </div>
                                <p>{block.contentBlocks10BlockText && parser(block.contentBlocks10BlockText)}</p>
                            </div>
                        </div>
                    ))}
                    <div className='col-md-12 mt-5 text-center'>
                        {contentBlocks10ButtonExternalLinks ? (
                            <a href={contentBlocks10ButtonExternalLinks} className="btn blue-btn">
                                {contentBlocks10ButtonText}
                            </a>
                        ) : contentBlocks10ButtonLink ? (
                            <Link to={contentBlocks10ButtonLink.uri} className='btn blue-btn'>
                                {contentBlocks10ButtonText}
                            </Link>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}
